import {
  type SerializedCompStructure,
  type StyledTextDataItem,
} from '@wix/document-services-types'

export function assertStyledTextData(
  data: NonNullable<SerializedCompStructure['data']>,
): asserts data is StyledTextDataItem {
  const TYPE: StyledTextDataItem['type'] = 'StyledText'
  if (data.type !== TYPE) {
    throw new Error('Not styled-text data.')
  }
}
